import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../helper/api";

export const addKYC = createAsyncThunk(
  "addKYC/addKYC",
  async (payload, thunkAPI) => {
    console.log(payload)
    try {
     
      const response = await api.post("KYC-details/add", payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
     
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const addKYCSlice = createSlice({
  name: "addKYC",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addKYC.pending, (state) => {
        state.loading = true;
      })
      .addCase(addKYC.fulfilled, (state, action) => {
          

        console.log(39, action)
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addKYC.rejected, (state, action) => {
        console.log(44, action)
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default addKYCSlice.reducer;
